import React from 'react';
import { Server, Cpu, HardDrive, Zap, CheckCircle2, ShieldCheck } from 'lucide-react';
import { Header } from '../components/Header.js';
import { EduCard } from '../components/EduCard.js';
import { EduBadge } from '../components/EduBadge.js';
import { EduProgressBar } from '../components/EduProgressBar.js';

export const Servers: React.FC = () => {
  return (
    <div>
      <Header
        title="Monitoramento de Servidores Linux"
        subtitle="Telemetria em tempo real dos droplets DigitalOcean, status de hardware e binários multimídia"
      />

      <div className="p-8 max-w-7xl mx-auto space-y-6">
        {/* Worker Node Card */}
        <EduCard
          title={
            <div className="flex items-center gap-2">
              <Server className="text-brand-primary" size={20} />
              <span>Worker Node #1 — DigitalOcean Droplet (Ubuntu Server 22.04 LTS)</span>
            </div>
          }
          subtitle="Hostname: edurender-worker-prod-01 • IP Interno: 10.116.0.2"
          action={<EduBadge variant="success" dot>Online & Operacional</EduBadge>}
          footer={
            <div className="flex items-center justify-between w-full text-xs text-txt-secondary">
              <span>Último heartbeat recebido: há 4 segundos</span>
              <span className="text-brand-primary font-semibold">Serviço: edurender-worker.service</span>
            </div>
          }
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div className="p-4 bg-surface-secondary border border-bdr rounded-xl">
              <div className="flex items-center justify-between text-xs text-txt-secondary mb-2">
                <span className="flex items-center gap-1.5 font-semibold">
                  <Cpu size={14} className="text-brand-primary" /> Uso de CPU
                </span>
                <span className="font-mono font-bold text-txt-primary">18%</span>
              </div>
              <EduProgressBar progress={18} showPercentage={false} />
              <span className="text-[11px] text-txt-muted mt-2 block">4 vCPUs dedicadas</span>
            </div>

            <div className="p-4 bg-surface-secondary border border-bdr rounded-xl">
              <div className="flex items-center justify-between text-xs text-txt-secondary mb-2">
                <span className="flex items-center gap-1.5 font-semibold">
                  <Zap size={14} className="text-status-warning" /> Memória RAM
                </span>
                <span className="font-mono font-bold text-txt-primary">34%</span>
              </div>
              <EduProgressBar progress={34} showPercentage={false} status="normal" />
              <span className="text-[11px] text-txt-muted mt-2 block">2.7 GB / 8.0 GB utilizados</span>
            </div>

            <div className="p-4 bg-surface-secondary border border-bdr rounded-xl">
              <div className="flex items-center justify-between text-xs text-txt-secondary mb-2">
                <span className="flex items-center gap-1.5 font-semibold">
                  <HardDrive size={14} className="text-status-info" /> Disco NVMe /opt/edurender
                </span>
                <span className="font-mono font-bold text-txt-primary">22%</span>
              </div>
              <EduProgressBar progress={22} showPercentage={false} status="normal" />
              <span className="text-[11px] text-txt-muted mt-2 block">124 GB livres de 160 GB</span>
            </div>
          </div>

          <h4 className="text-xs font-bold text-txt-primary uppercase tracking-wider mb-3">
            Validação de Ferramentas Multimídia Instaladas
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-xs">
            <div className="p-3 bg-surface border border-bdr rounded-lg flex items-center gap-2.5">
              <CheckCircle2 size={16} className="text-status-success shrink-0" />
              <div>
                <strong className="block text-txt-primary">FFmpeg v4.4.2</strong>
                <span className="text-[11px] text-txt-secondary">Suporte a libx264, aac, yuv420p</span>
              </div>
            </div>

            <div className="p-3 bg-surface border border-bdr rounded-lg flex items-center gap-2.5">
              <CheckCircle2 size={16} className="text-status-success shrink-0" />
              <div>
                <strong className="block text-txt-primary">FFprobe Integrado</strong>
                <span className="text-[11px] text-txt-secondary">Detecção exata de milissegundos</span>
              </div>
            </div>

            <div className="p-3 bg-surface border border-bdr rounded-lg flex items-center gap-2.5">
              <CheckCircle2 size={16} className="text-status-success shrink-0" />
              <div>
                <strong className="block text-txt-primary">Piper TTS Neural</strong>
                <span className="text-[11px] text-txt-secondary">Modelos Faber, Cadu, Jeff ativos</span>
              </div>
            </div>
          </div>
        </EduCard>
      </div>
    </div>
  );
};
